<template>
  <a-modal
    ref="createModal"
    title="新增"
    :width="850"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
    @ok="onConfirm"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row :gutter="20">
        <a-col :md="12" :sm="24">
          <a-form-model-item label="单据类型" prop="type" :rules="rules">
            <global-select
              selectType="selectSearch"
              v-model="form.type"
              :dropdown-match-select-width="false"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'SCP_DOC_TYPE' }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="申请人" prop="applicantUserNo" :rules="rules">
            <global-select
              :value.sync="form.applicantUserNo"
              selectType="selectSearch"
              requestApi="/mes/mesDiscreteJobs/founderBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              searchParam="jobCode"
              focusGet
              :selectData="defaultPersonList"
              @change="onChangeApplicant"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="物料编码" prop="itemCode" :rules="rules">
            <global-select
              v-model="form.itemCode"
              :focusGet="true"
              selectType="selectAssembleSearch"
              :dropdown-match-select-width="false"
              requestApi="/scp/scpMrpSystemItems/planItemsBox"
              :selectItem="{ value: 'selectedValue', label: 'label', thirdLabel: 'selectedValue' }"
              :setParams="{ organizationCode: 'A001' }"
              searchParam="label"
              sourseField="res"
              @change="(value, list) => onChangeMaterial(value, list)"
              :totalNum="9999999999"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="物料名称" prop="itemName">
            <a-input v-model="form.itemName" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="规格描述"
            prop="specification"
            :labelCol="{ span: 4 }"
            :wrapperCol="{ span: 20 }"
          >
            <a-input v-model="form.specification" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="供应商名称" prop="supplierName" :rules="rules">
            <global-select
              :value.sync="form.supplierName"
              selectType="selectSearch"
              requestApi="/mdm/mdmOrgSupplier/supplierNameList"
              :selectItem="{ value: 'label', label: 'realValue' }"
              searchParam="supplierName"
              @change="(value, list) => onChangeVendor(value, list)"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="供应商编码" prop="supplierCode">
            <a-input v-model="form.supplierCode" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划数量" prop="planQuantity" :rules="positiveNumRule">
            <a-input-number v-model="form.planQuantity" :min="0" :precision="0" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划周期" prop="planCycle" :rules="rules">
            <a-month-picker
              v-model="form.planCycle"
              valueFormat="YYYY-MM"
              format="YYYY-MM"
              allowClear
              class="full-width"
              :disabledDate="disabledDate"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="备注" prop="companyRemark">
            <a-input v-model="form.companyRemark" allowClear :maxLength="50" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import {
  apiAddPurchasePlanPool
} from '@/api/scp/month-plan-pool/month-plan-pool'
import { positiveNumValidate } from '../common'
import Cookie from 'js-cookie'
export default {
  name: 'AddModal',
  props: {},
  data () {
    return {
      confirmLoading: false,
      visible: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 16 }
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: [
        { required: true, message: ' ', trigger: 'change' }
      ],
      positiveNumRule: [ { required: true, validator: positiveNumValidate } ],
      defaultPersonList: [{ label: this.$store.state.user.name, realValue: Cookie.get('jobNo') }]
    }
  },
  created () {
    this.form = this.getInitData();
  },
  methods: {
    disabledDate(current) {
      return current < this.$moment().startOf('month');
    },
    onChangeApplicant(value, list) {
      const pItem = list.find(item => item.realValue === value);
      this.form.applicantUserName = pItem?.label;
    },
    onChangeMaterial(value, list) {
      const mItem = list.find(item => item.selectedValue === value);
      this.form.itemName = mItem?.bringOutDataOne;
      this.form.specification = mItem?.bringOutDataTwo;
    },
    onChangeVendor(value, list) {
      const vItem = list.find(item => item.label === value);
      this.form.supplierCode = vItem?.label;
      this.form.realVendorName = vItem?.realValue;
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    show () {
      this.visible = true
      this.confirmLoading = false
      console.log(this.$store.state)
    },
    // 关闭模态框
    onClose () {
      this.$refs.ruleForm.resetFields();
      this.visible = false
      this.reset()
    },
    // 保存
    onConfirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          apiAddPurchasePlanPool({ ...this.form, supplierName: this.form.realVendorName }).then(response => {
            if (response.code === 200) {
              this.$message.success('新增成功')
              // 关闭本组件
              this.visible = false
              // 调用外部刷新列表方法
              this.$emit('successCall')
              // 刷新表单
              this.reset()
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          return (this.confirmLoading = false)
        }
      })
    },
    // 表单重置
    reset () {
      this.form = this.getInitData();
    },
    getInitData() {
      return {
        type: undefined,
        applicantUserNo: Cookie.get('jobNo'),
        applicantUserName: this.$store.state.user.name,
        itemCode: undefined,
        itemName: undefined,
        specification: undefined,
        supplierName: undefined,
        supplierCode: undefined,
        planQuantity: undefined,
        planCycle: undefined,
        companyRemark: undefined
      }
    }
  }
}
</script>

<style  scoped lang="less">
/deep/.ant-modal-body{
  // height: 600px;
  overflow-y: scroll;
}
/deep/.ant-select{
  width: 100%;
}
input{
//  width: 100%;
//}
///deep/.ant-input-number{
//  width: 180px;
}
/deep/.ant-calendar-picker{
  min-width: 100% !important;
}
/deep/.ant-form-item-control{
  min-width: 100% !important;
}
</style>
